module.exports = __webpack_public_path__ + "static/img/sn.6264141.png";